import {mapActions} from 'vuex';

export default {
    methods: {
        // Vuex does not support mapping of Method-Style getters.
        getUserPreference(type, id = null) {
            return this.$store.getters['user/getUserPreference'](type, id);
        },
        ...mapActions({
            triggerIntercomEvent: 'triggerIntercomEvent',
            triggerGTMEvent: 'triggerGTMEvent',
            populateUserPreferences: 'user/populateUserPreferences',
            setUserPreference: 'user/setUserPreference',
        }),
    },
};
